import { IRewardActivityRespDto } from 'src/types/rewadr-acrivity.type'
import { EnhancedWithAuthHttpService } from './http-auth.service'
import { axiosInstance } from './http-common.service'
import { HttpService } from './http.service'

import { ERewardPointsTypes, IMessageResponseDto } from 'src/types'

class RewardActivityService extends EnhancedWithAuthHttpService {
  constructor() {
    super(new HttpService(axiosInstance))
  }

  getRewardActivity(params?: {}) {
    return this.get<IRewardActivityRespDto>('reward-activity/', { params })
  }

  getRewardActivityTypes() {
    return this.get<ERewardPointsTypes[]>('reward-activity/types', {})
  }

  getRewardActivityChallenges() {
    return this.get<string[]>('challenges/names', {})
  }

  getRewardActivityCsv(params: { challange_id: string }) {
    return this.get<any>('reward-activity/csv', { params })
  }

  removePendingRewardActivities(ids: string[]) {
    return this.delete<IMessageResponseDto>(`reward-activity/`, { data: { ids } })
  }
}

export const rewardActivityService = new RewardActivityService()
